/**
 * `ProviderLogo` — the logo for a matched agent in the Mandates list,
 * detail header, Overview feed and Agents page.
 *
 * Kept as the stable import for existing callers; the resolution lives in
 * `AgentLogo` (ADR-0242): Sill mark → bundled brand mark → the operator's
 * site icon fetched by Sill's API → monogram tile → User / Bot glyph.
 */

import { AgentLogo, isSillAgentId, type AgentLogoProps } from './AgentLogo.js';

export { isSillAgentId };

export type ProviderLogoProps = AgentLogoProps;

export function ProviderLogo(props: ProviderLogoProps): JSX.Element {
  return <AgentLogo {...props} />;
}
